import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearRecommendedPropertyAvailability,
  fetchRecommendedPropertyAvailability,
} from 'store/recommendedProperty/recommendedPropertyActions';
import { getFullKnownQuery } from 'store/router/routerSelectors';

const ResultsFetcher = () => {
  const dispatch = useDispatch();
  const query = useSelector(getFullKnownQuery);

  useEffect(() => {
    dispatch(fetchRecommendedPropertyAvailability());
    return () => {
      dispatch(clearRecommendedPropertyAvailability());
    };
  }, [dispatch, query]);

  return null;
};

export default ResultsFetcher;
